import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CnafAtTagService} from '@cnaf/ng-cnaf-commons';
import { TagXitiService } from '../services/tagxiti.service';
import { context } from '../../../src/contexts/context';


declare let changeContextChatbotAppliMobile: (rubrique: string, dialog: string) => void;
declare let reinitContextChatbotAppliMobile: () => void;

@Component({
  selector: 'cnaf-contacter-caf-echec-svi',
  templateUrl: './contactermacaf-echec-svi.component.html',
  styleUrls: ['./contactermacaf-echec-svi.component.css']
})

export class ContacterMaCafEchecSviComponent implements OnInit, OnDestroy {
  codeOrga!: string;
  message = "";
  source = '';

  constructor(private router: Router, private route: ActivatedRoute, private readonly tagXitiService: TagXitiService,
    private readonly cnafAtTagService: CnafAtTagService) { }

  ngOnDestroy(): void {
    if (typeof reinitContextChatbotAppliMobile === 'function') {
      reinitContextChatbotAppliMobile();
    }
  }

  clickOnRetour(): void {
    this.router.navigateByUrl("./contactcaf");
  }

  ngOnInit(): void {
    this.message = this.route.snapshot.queryParamMap.get("message") || "indisponible";
    this.source = this.route.snapshot.queryParamMap.get("source") || "inconnue";

    let chapitre2 = 'svi_visuel_sans_motif';
    if(this.source === 'avecmotifsdecontact'){
      chapitre2 = 'svi_visuel_avec_motif';
    }
    const tagObj = this.tagXitiService.getAtTagObject('pfs_indisponible_ferme', context.type, 'contactermacaf', chapitre2, 'appeler');
    tagObj.customPropsPersistent = {
      'svi_profil': this.tagXitiService.getProfilutilisateur()
    };
    this.cnafAtTagService.pageSend(tagObj);

    if (typeof changeContextChatbotAppliMobile === 'function') {
      changeContextChatbotAppliMobile('SVI_VISUEL', 'testsvicontext');
    }
  }
}
